import axiosInstance from './axiosInstance';

export const registerUser = async (data) => {
  const response = await axiosInstance.post('/auth/register', data);
  return response.data;
};

export const loginUser = async (data) => {
  const response = await axiosInstance.post('/auth/login', data);
  return response.data;
};

export const verifyEmail = async (token) => {
  const response = await axiosInstance.get(`/auth/verify-email?token=${token}`);
  return response.data;
};

export const forgotPassword = async (email) => {
  const response = await axiosInstance.post(`/auth/forgot-password?email=${email}`);
  return response.data;
};

export const resetPassword = async (token, newPassword) => {
  const response = await axiosInstance.post(
    `/auth/reset-password?token=${token}&newPassword=${newPassword}`
  );
  return response.data;
};